import { Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { addTax, updateTax } from "../../../../Api/Signin/Transaction.Api";
import { ReactComponent as TaxBag } from "../../../../Assets/Images/Icon/TAXICON.svg";
import useLoadingState from "../../../../Utils/Hooks/useLodingState";
import useOverlayState from "../../../../Utils/Hooks/useOverlayState";
import { HorizontalDivide } from "../../../atoms/HorizontalDivide/HorizontalDivide";
import { NumberInputType3 } from "../../../atoms/Input/NumberInput";
import { TextInput } from "../../../atoms/Input/TextInput";
import { LoadingButtonType } from "../../../atoms/LoadingButton/LoadingButton";
import { Heading3 } from "../../../atoms/Typography/Heading/Heading";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";

export const TaxConfiguarationAddContent = ({
  control,
  setContentID,
  isUpdate,
  id,
  reset,
  handleSubmit,
  taxLoader,
  setError,
  closeDrawer,
}) => {
  const { t } = useTranslation();
  const { OverlayState, openOverlay, closeOverlay } = useOverlayState();
  const { startLoading, stopLoading, LoadingState } = useLoadingState();
  const submitHandler = async (e) => {
    try {
      startLoading({ btnName: "add" });
      let response;
      if (isUpdate && id) {
        response = await updateTax({ id: id, tax: e.tax, value: e.value });
      } else {
        response = await addTax({ tax: e.tax, value: e.value });
      }
      if (response.type === 0) {
        reset({ tax: "", value: "" });
        taxLoader();
        setContentID({
          sceneID: 0,
          isUpdate: false,
        });
      } else {
        if (response.message == "tax-updated-early") {
          openOverlay({ OverlayName: "tax-updated-early" });
        } else {
          setError("tax", {
            message: t(response.message, { ns: "validation" }),
          });
        }
      }
      stopLoading({ btnName: "add" });
    } catch (exception) {
      stopLoading({ btnName: "add" });
    }
  };
  return (
    <>
      <Stack direction={"column"}>
        <Heading3
          icon={<TaxBag />}
          text={
            isUpdate
              ? t("glossary:tax-configuration:update-tax")
              : t("glossary:tax-configuration:add-tax")
          }
        />
        <form onSubmit={handleSubmit(submitHandler)}>
          <Stack mt={"16px"} ml={"23px"} direction={"column"} spacing={2}>
            <TextInput
              label={t("common:table-field.name")}
              required
              control={control}
              name={"tax"}
              size={"large"}
            />
            <NumberInputType3
              width={"100%"}
              label={t("common:form:percentage")}
              required
              control={control}
              name={"value"}
              size={"large"}
            />
            <Stack>
              <HorizontalDivide marginTop={"30px"} height={"0.5px"} />
            </Stack>
          </Stack>

          <Stack
            mt={"20px"}
            mb={"20px"}
            direction={"row"}
            justifyContent={"flex-end"}
            alignItems={"center"}
          >
            <Button
              onClick={() => {
                reset({ tax: "", value: "" });
                taxLoader();
                setContentID({
                  sceneID: 0,
                  isUpdate: false,
                });
              }}
              variant="whiteSquare"
              sx={{ maxHeight: "50px" }}
            >
              {t("common:button:cancel")}
            </Button>
            <LoadingButtonType
              loading={LoadingState.visible}
              type="submit"
              variant="primaryBlue"
              sx={{ maxHeight: "50px" }}
            >
              {isUpdate ? t("common:action:update") : t("common:action:save")}
            </LoadingButtonType>
          </Stack>
        </form>
      </Stack>
      {OverlayState.OverlayName === "tax-updated-early" && (
        <ConfirmDialog
          open={true}
          close={() => {
            reset({ tax: "", value: "" });
            closeDrawer();
            closeOverlay();
          }}
          title={t("common:alert-confirm:save-conflict")}
          description={t("validation:tax-updated-early")}
          onOkClick={() => {
            reset({ tax: "", value: "" });
            closeDrawer();
            closeOverlay();
          }}
          onOkTitle={t("common:action:ok")}
        />
      )}
    </>
  );
};
